module.exports = "/images/mara.jpg?f22a7d0283f6bec0394a3209ca929658";